// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__9gI8c","amount":"Amount_amount__QQbyX","tip":"Amount_tip__jCfJr","tipHeader":"Amount_tipHeader__3NR1V","tipsWrap":"Amount_tipsWrap__1Kkzz"};